import React from "react";

const OtpBottomSheet = ({
  otpOpen,
  otpStep,
  phoneDigits,
  phoneDigitsConfirm,
  otpCode,
  phoneNumber,
  phoneInputRef,
  otpInputRef,
  setOtpOpen,
  setPhoneDigits,
  setPhoneDigitsConfirm,
  setOtpCode,
  sendOtp,
  verifyOtp,
  forceFocus,
  loadingPhone,
  loadingOtp,
  setUserEditingPhone,
}) => {
  if (!otpOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="otp-overlay"
        onMouseDown={(e) => {
          e.preventDefault();
        }}
        onTouchStart={(e) => {
          e.preventDefault();
        }}
        onClick={() => setOtpOpen(false)}
      />

      {/* Bottom Sheet */}
      <div className="otp-sheet">
        {otpStep === "phone" && (
          <>
            <h3>📱 Conferma numero</h3>
            <p>
              Serve solo per avvisarti sullo stato dell'ordine.
            </p>

            <div className="otp-phone-row" style={{ display: "flex", gap: "8px", alignItems: "center", position: "relative" }}>
              <span className="otp-prefix" style={{
                padding: "10px 12px",
                background: "#222",
                borderRadius: "8px",
                fontWeight: "600",
                color: "#fff",
                zIndex: 1,
                pointerEvents: "none"
              }}>
                +39
              </span>

              <input
                className="otp-phone-input"
                ref={phoneInputRef}
                type="text"
                inputMode="numeric"
                autoComplete="tel"
                maxLength={10}
                placeholder="Numero di telefono"
                value={phoneDigits}
                onFocus={() => setUserEditingPhone(true)}
                onBlur={() => setUserEditingPhone(false)}
                onChange={(e) => {
                  const v = e.target.value;
                  if (/^\d*$/.test(v)) {
                    setPhoneDigits(v);
                  }
                }}
                style={{
                  flex: 1,
                  padding: "12px",
                  borderRadius: "8px",
                  fontSize: "16px",
                  zIndex: 2,
                  position: "relative"
                }}
              />
            </div>

            <div className="otp-phone-row" style={{ display: "flex", gap: "8px", alignItems: "center", marginTop: "12px", position: "relative" }}>
              <span className="otp-prefix" style={{
                padding: "10px 12px",
                background: "#222",
                borderRadius: "8px",
                fontWeight: "600",
                color: "#fff",
                zIndex: 1,
                pointerEvents: "none"
              }}>
                +39
              </span>

              <input
                className="otp-phone-input"
                type="tel"
                inputMode="numeric"
                autoComplete="tel"
                maxLength={10}
                placeholder="Conferma numero di cellulare"
                value={phoneDigitsConfirm}
                onFocus={() => setUserEditingPhone(true)}
                onBlur={() => setUserEditingPhone(false)}
                onChange={(e) => {
                  const v = e.target.value;
                  if (/^\d*$/.test(v)) {
                    setPhoneDigitsConfirm(v);
                  }
                }}
                style={{
                  flex: 1,
                  padding: "12px",
                  borderRadius: "8px",
                  fontSize: "16px",
                  zIndex: 2,
                  position: "relative"
                }}
              />
            </div>

            <button
              className="otp-primary-btn"
              disabled={loadingPhone}
              onClick={() => {
                if (!phoneDigits.trim()) return;
                sendOtp();
              }}
            >
              {loadingPhone ? (
                <>
                  <span className="spinner-inline"></span> Invio in corso...
                </>
              ) : (
                "Invia codice"
              )}
            </button>
          </>
        )}

        {otpStep === "code" && (
          <>
            <h3>🔐 Inserisci codice</h3>
            <p>
              Abbiamo inviato un SMS a<br />
              <strong>{phoneNumber}</strong>
            </p>

            <input
              ref={otpInputRef}
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              placeholder="••••••"
              maxLength={6}
              value={otpCode}
              onBlur={() => {
                // Riporta focus SOLO se il bottom sheet è ancora aperto nello step giusto
                // e se il focus non è già sull'input (evita loop)
                if (
                  otpOpen &&
                  otpStep === "code" &&
                  otpInputRef.current !== document.activeElement
                ) {
                  forceFocus(otpInputRef);
                }
              }}
              onChange={(e) => {
                const v = e.target.value;
                if (/^\d*$/.test(v)) {
                  setOtpCode(v);
                }
              }}
              className="otp-input otp-code"
            />

            <button
              className="otp-primary-btn"
              disabled={loadingOtp}
              onClick={() => {
                if (otpCode.length < 4) return;
                verifyOtp();
              }}
            >
              {loadingOtp ? (
                <>
                  <span className="spinner-inline"></span> Verifica in corso...
                </>
              ) : (
                "Conferma"
              )}
            </button>
          </>
        )}

        {otpStep === "success" && (
          <>
            <h3>✅ Numero verificato</h3>
            <p>Stiamo inviando il tuo ordine…</p>
          </>
        )}
      </div>
    </>
  );
};

export default OtpBottomSheet;
